import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { i18nReady } from './i18n'

/* The prerendered crawler block (`#llm-content`) is a full second copy of
   the page — its own h1, its own sections, its own CTA link — parked
   off-screen at left:-9999px for crawlers that do not run JS.
 *
 * Once React has rendered, that audience is gone and the block is pure
 * liability: a screen reader reads two documents and two h1s, a keyboard
 * user tabs into an invisible link, and because it lives in <body> rather
 * than in #root it survives every client-side navigation — so a visitor
 * who lands on /services/seo carries its hidden tree and its CTA onto
 * every route afterwards.
 *
 * It is still in the HTML a non-JS crawler receives, which is the whole
 * point of generating it. It is `inert`/`aria-hidden` in the markup too,
 * so it is harmless in the window before this runs.
 */
document.getElementById('llm-content')?.remove()

/* Routes and translations are content-hashed chunks. A tab opened before a
   deploy still asks for the old hashes, which the new deploy no longer
   has; the import fails and the route would render nothing. Vite reports
   that as `vite:preloadError`, so reload once to pick up the new build.
   The timestamp stops a genuinely missing file from reloading in a loop. */
window.addEventListener('vite:preloadError', (event) => {
	const key = 'jamak:chunk-reload'
	try {
		if (Date.now() - Number(sessionStorage.getItem(key) || 0) < 10000) return
		sessionStorage.setItem(key, String(Date.now()))
	} catch {
		// Storage blocked: reload anyway; a loop needs storage to be detected.
	}
	event.preventDefault()
	window.location.reload()
})

/* English renders at once (its core strings are in this bundle); Spanish
   waits for its own, which the static HTML already preloads. Render either
   way, even if that fetch failed — fallback strings beat an empty page. */
const render = () =>
	ReactDOM.createRoot(document.getElementById('root')).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	)
i18nReady.then(render, render)
